import { Box, ButtonBase, Typography } from '@mui/material';
import QuestionIcon from '@mui/icons-material/HelpOutline';
import { StyledTable, StyledTd, StyledTh, StyledTr } from '../styles/table';
import { useIsOpen } from 'integration/hooks/useIsOpen';
import { ProductDetailsShoesHowToMeasure } from '@/components/blocks/ProductDetails/SizesGuideModal/parts/HowToMeasure';
import { PDPShoeSize } from '@/data/types/PdpSizes';

interface Props {
	data: PDPShoeSize[];
}

export const ProductDetailsShoesScenery: React.FC<Props> = ({ data }) => {
	const showInfo = useIsOpen();

	return (
		<Box
			sx={{
				width: '100%',
				height: '100%',
				display: 'flex',
				flexDirection: 'column',
				gap: '20px',
			}}
		>
			{showInfo.open ? (
				<ProductDetailsShoesHowToMeasure onClose={showInfo.off} />
			) : (
				<>
					<Box>
						<Typography
							sx={{
								fontSize: '15px',
								fontWeight: 500,
								marginBottom: '10px',
							}}
						>
							{
								'Las tallas de calzado están expresados en la medida local (MX), recomendamos tenerlo en cuenta al momento de realizar tu compra o al revisarlo en la guía de tallas'
							}
						</Typography>

						<ButtonBase
							sx={{
								color: '#9C3F74',
								fontSize: '16px',
								width: 'fit-content',
								display: 'flex',
								alignItems: 'center',
								cursor: 'pointer',
								gap: '5px',
							}}
							onClick={showInfo.on}
						>
							<QuestionIcon fontSize="inherit" />
							{'¿Cómo medirme?'}
						</ButtonBase>
					</Box>

					<Box
						sx={{
							overflowY: 'auto',
							flex: 1,
						}}
					>
						<StyledTable>
							<thead>
								<tr>
									<StyledTh>{'MX'}</StyledTh>
									<StyledTh>{'US'}</StyledTh>
									<StyledTh>{'CM'}</StyledTh>
									<StyledTh>{'Pulgadas'}</StyledTh>
								</tr>
							</thead>
							<tbody>
								{data.map((item) => (
									<StyledTr key={item.mx}>
										<StyledTd>{item.mx}</StyledTd>
										<StyledTd>{item.us}</StyledTd>
										<StyledTd>{item.cm}</StyledTd>
										<StyledTd>{item.in}</StyledTd>
									</StyledTr>
								))}
							</tbody>
						</StyledTable>
					</Box>
				</>
			)}
		</Box>
	);
};
